module.exports = __webpack_public_path__ + "img/default-banner-old.1c537132.jpg";